<template>
  <v-container fluid>
    <ModalAplicativo
      :modalAplicativo="modalAplicativo"
      :editAplicativo="editAplicativoObj"
      @close="closeModalAplicativo"
    />
    <Grid
      title="Aplicativos"
      :headers="headers"
      :items="aplicativos"
      @novo="modalAplicativo = true"
      @edit="editAplicativo"
      @destroy="destroyAplicativo"
      @atualiza="getAplicativos"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Grid from '@/components/shared/Grid';
import ModalAplicativo from '@/components/aplicativo/ModalAplicativo';

export default {
  name: 'Aplicativos',
  data: () => ({
    modalAplicativo: false,
    editAplicativoObj: null,
    headers: [
      {
        text: 'Descrição',
        align: 'start',
        value: 'descricao',
      },
      { text: 'ID', value: '_id' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
  }),
  components: {
    Grid,
    ModalAplicativo
  },
  computed: {
    ...mapGetters(['aplicativos'])
  },
  methods: {
    ...mapActions(['fetchAplicativos', 'deleteAplicativo']),
    closeModalAplicativo() {
      this.editAplicativoObj = null;
      this.modalAplicativo = false;
    },
    getAplicativos() {
      this.fetchAplicativos({ limit: 999 });
    },
    editAplicativo(aplicativo) {
      this.editAplicativoObj = { ...aplicativo };
      this.modalAplicativo = true;
    },
    destroyAplicativo(aplicativo) {
      if (confirm(`Tem certeza que deseja excluir o aplicativo: ${aplicativo.descricao}?`)) {
        this.deleteAplicativo(aplicativo._id);
      }
    }
  },
  created() {
    this.getAplicativos();
  }
}
</script>

<style>

</style>